(function () {
  var shouldOpenDrawer = false;
  var recommendationsLoaded = false;
  var recommendationsLoading = false;
  var closeTimer = null;

  function getDrawer() {
    return document.getElementById('cart-drawer');
  }

  function setTriggerState(expanded) {
    document.querySelectorAll('[data-cart-drawer-trigger], .js-cart-icon').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function hydrateDrawerImages(scope) {
    var root = scope || document;

    root.querySelectorAll('.cart-drawer img[data-src]').forEach(function (image) {
      if (image.dataset.srcset) {
        image.setAttribute('srcset', image.dataset.srcset);
        image.removeAttribute('data-srcset');
      }

      if (image.dataset.sizes) {
        image.setAttribute('sizes', image.dataset.sizes);
        image.removeAttribute('data-sizes');
      }

      image.setAttribute('src', image.dataset.src);
      image.removeAttribute('data-src');
    });
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('open');
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');
    hydrateDrawerImages(drawer);
    setTriggerState(true);
    scheduleAiRecommendations();
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('open');
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
    setTriggerState(false);

    if (closeTimer) window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      if (!drawer.classList.contains('open')) {
        drawer.hidden = true;
      }
    }, 340);
  }

  function scheduleIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1200 });
      return;
    }

    window.setTimeout(callback, 300);
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    document.querySelectorAll('#cart-svg-count, #CartCount, #mobile-cart-svg-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('cart-show', cart.item_count > 0);
      el.classList.toggle('cart-extra-pad', cart.item_count > 9);
    });

    document.querySelectorAll('.cart-wrapper, .js-cart-icon').forEach(function (el) {
      el.classList.toggle('cart-show', cart.item_count > 0);
    });
  }

  async function getCart() {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    return response.json();
  }

  function addUnique(array, value) {
    if (value && array.indexOf(value) === -1) {
      array.push(value);
    }
  }

  function getDrawerProductHandles() {
    var drawer = getDrawer();
    if (!drawer) return [];

    return Array.prototype.slice.call(drawer.querySelectorAll('.cart-drawer__item[data-product-handle]')).map(function (item) {
      return item.getAttribute('data-product-handle');
    }).filter(Boolean);
  }

  function getProductSectionUrl(handle) {
    var root = window.theme && window.theme.routes && window.theme.routes.store_path ? window.theme.routes.store_path : '';
    root = root.replace(/\/$/, '');
    return root + '/products/' + encodeURIComponent(handle) + '?section_id=cart-fbt';
  }

  async function refreshDrawer() {
    var response = await fetch('/?section_id=cart-drawer', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    });
    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newPanel = doc.querySelector('.cart-drawer__panel');
    var currentPanel = document.querySelector('.cart-drawer__panel');

    if (newPanel && currentPanel) {
      currentPanel.innerHTML = newPanel.innerHTML;
      hydrateDrawerImages(currentPanel);
    }
  }

  async function refreshDrawerAndCount(cart) {
    await refreshDrawer();

    if (cart) {
      updateCartCount(cart);
    } else {
      updateCartCount(await getCart());
    }

    recommendationsLoaded = false;
    recommendationsLoading = false;
    document.body.dispatchEvent(new CustomEvent('theme:ajaxCart:updateSuccess'));
    scheduleAiRecommendations();
  }

  async function loadAiRecommendations() {
    var drawer = getDrawer();
    var container = drawer ? drawer.querySelector('.cart-ai-recommendations') : null;

    if (!drawer || !drawer.classList.contains('open') || !container) return;
    if (recommendationsLoaded || recommendationsLoading) return;

    if (container.querySelector('.cart-ai-item')) {
      hydrateDrawerImages(container);
      recommendationsLoaded = true;
      recommendationsLoading = false;
      return;
    }

    recommendationsLoading = true;
    container.innerHTML = '';

    try {
      var cart = await getCart();

      if (!cart.items || !cart.items.length) {
        recommendationsLoaded = true;
        recommendationsLoading = false;
        return;
      }

      var orderedCartItems = cart.items.slice().reverse();
      var cartHandles = [];

      orderedCartItems.forEach(function (item) {
        addUnique(cartHandles, item.handle);
      });

      getDrawerProductHandles().forEach(function (handle) {
        addUnique(cartHandles, handle);
      });

      if (!cartHandles.length) {
        recommendationsLoaded = true;
        recommendationsLoading = false;
        return;
      }

      var cartHandleSet = new Set(cartHandles);
      var typeMap = new Map();

      orderedCartItems.forEach(function (item) {
        var handle = item.handle;
        var productType = (item.product_type || 'unknown').trim().toLowerCase();

        if (!handle) return;

        if (!typeMap.has(productType)) {
          typeMap.set(productType, {
            sourceHandles: [],
            items: []
          });
        }

        var group = typeMap.get(productType);
        if (group.sourceHandles.indexOf(handle) === -1) {
          group.sourceHandles.push(handle);
        }
      });

      if (!typeMap.size) {
        typeMap.set('cart', {
          sourceHandles: cartHandles.slice(),
          items: []
        });
      } else {
        var groupedHandles = new Set();

        typeMap.forEach(function (group) {
          group.sourceHandles.forEach(function (handle) {
            groupedHandles.add(handle);
          });
        });

        cartHandles.forEach(function (handle) {
          if (groupedHandles.has(handle)) return;

          var fallbackGroup = typeMap.get('cart');

          if (!fallbackGroup) {
            fallbackGroup = {
              sourceHandles: [],
              items: []
            };
            typeMap.set('cart', fallbackGroup);
          }

          if (fallbackGroup.sourceHandles.indexOf(handle) === -1) {
            fallbackGroup.sourceHandles.push(handle);
          }
        });
      }

      for (var group of typeMap.values()) {
        var seenWithinType = new Set();

        for (var handle of group.sourceHandles) {
          try {
            var response = await fetch(getProductSectionUrl(handle), {
              credentials: 'same-origin',
              headers: { Accept: 'text/html' }
            });
            var html = await response.text();
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = Array.prototype.slice.call(doc.querySelectorAll('.cart-ai-item'));

            for (var itemEl of items) {
              var link = itemEl.querySelector('.cart-ai-link');
              if (!link) continue;

              var href = link.getAttribute('href') || '';
              var matchedHandle = href.split('/products/')[1]?.split('?')[0]?.split('/')[0];

              if (!matchedHandle) continue;
              if (cartHandleSet.has(matchedHandle)) continue;
              if (seenWithinType.has(matchedHandle)) continue;

              seenWithinType.add(matchedHandle);
              group.items.push({
                handle: matchedHandle,
                html: itemEl.outerHTML
              });
            }
          } catch (error) {}
        }
      }

      var recommendationBuckets = Array.prototype.slice.call(typeMap.values()).filter(function (group) {
        return group.items.length;
      });

      if (!recommendationBuckets.length) {
        recommendationsLoaded = true;
        recommendationsLoading = false;
        return;
      }

      var usedHandles = new Set(cartHandleSet);
      var finalItems = [];
      var limit = 6;
      var addedInPass = true;

      while (finalItems.length < limit && addedInPass) {
        addedInPass = false;

        for (var bucket of recommendationBuckets) {
          while (bucket.items.length) {
            var candidate = bucket.items.shift();

            if (!candidate || !candidate.handle) continue;
            if (usedHandles.has(candidate.handle)) continue;

            usedHandles.add(candidate.handle);
            finalItems.push(candidate);
            addedInPass = true;
            break;
          }

          if (finalItems.length >= limit) break;
        }
      }

      if (finalItems.length) {
        var currentContainer = getDrawer() ? getDrawer().querySelector('.cart-ai-recommendations') : null;
        if (!currentContainer) {
          recommendationsLoaded = true;
          recommendationsLoading = false;
          return;
        }

        currentContainer.innerHTML =
          '<div class="cart-fbt-block">' +
            '<p class="cart-fbt-heading">Frequently Bought Together</p>' +
            '<div class="cart-ai-grid">' +
              finalItems.map(function (item) { return item.html; }).join('') +
            '</div>' +
          '</div>';
      }

      recommendationsLoaded = true;
      recommendationsLoading = false;
    } catch (error) {
      recommendationsLoaded = true;
      recommendationsLoading = false;
      container.innerHTML = '';
    }
  }

  function scheduleAiRecommendations() {
    scheduleIdle(loadAiRecommendations);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cart-drawer-trigger], .js-cart-icon')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openDrawer();
    refreshDrawerAndCount().catch(function () {});
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-drawer__close') || event.target.classList.contains('cart-drawer__overlay')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-form__submit')) {
      shouldOpenDrawer = true;
    }
  }, true);

  document.body.addEventListener('theme:ajaxCart:addSuccess', function () {
    if (!shouldOpenDrawer) return;

    shouldOpenDrawer = false;
    openDrawer();
    refreshDrawerAndCount().catch(function () {});
  });

  document.addEventListener('click', async function (event) {
    var boostButton = event.target.closest('.boost-sd__btn-add-to-cart');
    if (!boostButton) return;

    var variantId = boostButton.dataset.variantId || boostButton.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();
    boostButton.setAttribute('aria-disabled', 'true');

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!response.ok) return;

      openDrawer();
      await refreshDrawerAndCount();
    } finally {
      boostButton.removeAttribute('aria-disabled');
    }
  }, true);

  document.addEventListener('click', async function (event) {
    var minus = event.target.closest('.cart-drawer__qty .minus');
    var plus = event.target.closest('.cart-drawer__qty .plus');
    var remove = event.target.closest('.cart-drawer__remove');

    if (!minus && !plus && !remove) return;

    var item = event.target.closest('.cart-drawer__item');
    if (!item) return;

    var key = item.dataset.key;
    var valueBox = item.querySelector('.qty-value');
    var qty = parseInt(valueBox ? valueBox.textContent : '0', 10) || 0;

    if (minus) qty = Math.max(0, qty - 1);
    if (plus) qty += 1;
    if (remove) qty = 0;

    item.classList.add('is-loading');

    try {
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      var cart = await response.json();
      await refreshDrawerAndCount(cart);
    } catch (error) {
      item.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.cart-more-toggle');
    if (!toggle) return;

    var drawer = getDrawer();
    var content = drawer ? drawer.querySelector('.cart-more-content') : null;
    var expanded = !toggle.classList.contains('open');

    toggle.classList.toggle('open');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (content) content.classList.toggle('open');
  });

  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;
})();
